export interface EntryMethod {
  id: string;
  bundleName: string;
  type: string;
  iconUrl: string;
}

export enum EntryType {
  FOOT = "none",
  CAR = "car",
  BICYCLE = "bike",
}
